<template>
  <div class="myinfo">
    <template v-if="list.length > 0">
      <div class="tab" v-for="item in list" :key="item.id">
        <div class="left">
          <div class="title">
            <div class="line"></div>
            {{ item.dict.applyType }}
          </div>
          <div class="time">
            <img src="./imagas/changeState/icon_1.png" />
            提交时间： {{ item.createTime }}
          </div>
          <div class="status">办理状态：{{ item.dict.state }}</div>
        </div>
      </div>
    </template>
    <a-empty v-else />
  </div>
</template>

<script>
export default {
  name: "ChangeStatefirst",
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      let res = await this.axios.get(`/biz/archive/apply/list`, {
        params: { type: 0 },
      });
      this.list = res.result;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.myinfo {
  background: #fff;
  padding: 28px;
  padding-top: 12px;
  margin-top: 20px;
  .tab{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 18px 0;
    border-bottom:1px solid #EFEFEF;
    flex: 1;
    .left{
        display: flex;
        align-items: center;
        .title {
        display: flex;
        align-items: center;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 16px;
        color: #495057;
        line-height: 32px;
        width: 140px;
            .line {
                width: 4px;
                height: 15px;
                border-radius: 2px;
                margin-right: 10px;
                background: #27C393;
            }
        }
        .time {
            display: flex;
            align-items: center;
            margin-left: 62px;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #999999;
            line-height: 32px;
            margin-right: 30px;
            img{
                width: 16px;
                height: 16px;
                margin-right: 10px;
            }
        }
        .status{
            font-family: SourceHanSansCN, SourceHanSansCN;
            font-weight: 400;
            font-size: 14px;
            color: #2CAF7A;
            line-height: 32px;
            
        }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/ViewStatus.vue